import Vue from 'vue'
import { jobsUiDebugLog } from '@/utils/jobsUiDebug'

export default {
  startIndexing(state) { state.isReindexing = true },
  stopIndexing(state) { state.isReindexing = false },
  setScreenLayouts(state, layouts) {
    state.screenLayouts = layouts
  },
  screenLayoutItemAdded(state, screenLayoutItem) {
    const item = {
      id: screenLayoutItem.id,
      type: screenLayoutItem.type,
      label: screenLayoutItem.label,
      bucketGroupId: screenLayoutItem.bucketGroupId,
      teamId: screenLayoutItem.teamId,
      position: screenLayoutItem.position
    }
    state.screenLayouts.push(item)
  },
  screenLayoutItemRemoved(state, id) {
    const ids = state.screenLayouts.map(layout => layout.id)
    const index = ids.indexOf(id)
    state.screenLayouts.splice(index, 1)
  },
  setMyJobs(state, data) {
    state.jobs.myJobs = data.jobs
  },
  setAllJobs(state, data) {
    state.jobs.allJobs = data.jobs
  },
  setTotalPages(state, data) {
    state.jobs.pages = data.pageTotal
  },
  patchJobFromSubscription(state, { update }) {
    if (!update || update.jobId === undefined || update.jobId === null) {
      jobsUiDebugLog("patchJobFromSubscription:skip", { reason: "missing_update" })
      return
    }
    const id = Number(update.jobId)
    if (!Number.isFinite(id)) {
      jobsUiDebugLog("patchJobFromSubscription:skip", { reason: "bad_jobId", jobId: update.jobId })
      return
    }
    const apply = (list, listName) => {
      if (!list || list.length === 0) {
        return
      }
      const idx = list.findIndex((j) => Number(j.id) === id)
      if (idx === -1) {
        jobsUiDebugLog("patchJobFromSubscription:not_in_list", { list: listName, jobId: id })
        return
      }
      const prev = list[idx]
      const merged = Object.assign({}, prev, {
        jobType: update.jobType,
        jobStatus: update.jobStatus,
        currentStep: update.currentStep,
        totalSteps: update.totalSteps,
        succeeded: update.succeeded,
        failed: update.failed,
        updatedAt: update.updatedAt !== undefined && update.updatedAt !== null ? update.updatedAt : prev.updatedAt,
        createdAt: update.createdAt !== undefined && update.createdAt !== null ? update.createdAt : prev.createdAt,
      })
      Vue.set(list, idx, merged)
      jobsUiDebugLog("patchJobFromSubscription:applied", {
        list: listName,
        jobId: id,
        prevSucceeded: prev.succeeded,
        prevFailed: prev.failed,
        nextSucceeded: merged.succeeded,
        nextFailed: merged.failed,
        prevStatus: prev.jobStatus,
        nextStatus: merged.jobStatus,
        prevStep: prev.currentStep,
        nextStep: merged.currentStep,
      })
    }
    apply(state.jobs.myJobs, "myJobs")
    apply(state.jobs.allJobs, "allJobs")
  },
  clearJobLog(state) {
    Vue.set(state, 'jobLogs', [])
  },
  getJobLog(state, logs) {
    Vue.set(state, 'jobLogs', [...logs])
  }
}
